module.exports = __webpack_public_path__ + "static/media/image 30.7ece6669.png";